export enum UserRole {
  SuperAdmin,
  Admin,
  FarmManager,
  Viewer,
  Developer,
  Manager,
  Supervisor,
  Operator,
  Contractor,
}
